import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, LoadingContent, Select } from '../../../components'
import PdcaLayout from '../base/pdcaLayout'
import PdcaPageHeader from '../components/pdcapageheader/pdcapageheader'
import PdcaEmptyState from '../components/pdcaemptystate/pdcaemptystate'
import {
  clearBlacklist,
  fetchBlacklist,
  removeBlacklistAction,
  selectBlacklistItem
} from './redux/blacklistActions'
import './blacklist.scss'

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const {
    projetoId,
    empresaPdcaExiste,
    contextoCarregado
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const {
    acoes = [],
    selecionada = null,
    loading = false,
    removing = false,
    removingId = null,
    error = null
  } = useSelector(state => state.pdcaState.pdcaBlacklistState || {})

  const contextoValido =
    contextoCarregado &&
    String(projetoId) === String(idProjetos)

  useEffect(() => {
    return () => {
      dispatch(clearBlacklist())
    }
  }, [dispatch])

  useEffect(() => {
    if (!idProjetos || !contextoValido || !empresaPdcaExiste) return

    dispatch(fetchBlacklist(idProjetos))
  }, [
    dispatch,
    idProjetos,
    contextoValido,
    empresaPdcaExiste
  ])

  const contextoInconsistente = contextoCarregado && !empresaPdcaExiste
  const total = acoes.length
  const subtitle = `${total} ${total === 1 ? nls.summaryItemSingular : nls.summaryItemPlural}`

  const handleSelecionarAcao = e => {
    dispatch(selectBlacklistItem(e?.value || null))
  }

  const handleRemover = () => {
    if (!selecionada?.id) return

    dispatch(removeBlacklistAction({
      projetoId: idProjetos,
      acaoId: selecionada.id
    }))
  }

  return (
    <PdcaLayout>
      <div className='box-pdca-blacklist'>
        <PdcaPageHeader
          title={nls.pageTitle}
          subtitle={subtitle}
        />

        {contextoInconsistente && (
          <div className='box-pdca-blacklist-inline-error'>
            {nls.contextError}
          </div>
        )}

        {!contextoInconsistente && (
          <LoadingContent loading={loading}>
            {error && (
              <div className='box-pdca-blacklist-inline-error'>
                {error || nls.loadError}
              </div>
            )}

            {!error && (
              <>
                {acoes.length ? (
                  <div className='box-pdca-blacklist-content'>
                    <div className='box-pdca-blacklist-select-box'>
                      <div className='box-pdca-blacklist-select'>
                        <Select
                          name='blacklistAction'
                          label={nls.listTitle}
                          options={acoes}
                          selected={selecionada || {}}
                          action={handleSelecionarAcao}
                          selectedItem={false}
                          optionLabel='titulo'
                          optionValue='id'
                          disabled={loading || acoes.length === 0}
                        />
                      </div>
                    </div>

                    <div className='box-pdca-blacklist-detail'>
                      {selecionada ? (
                        <div className='box-pdca-blacklist-detail-card'>
                          <div className='box-pdca-blacklist-detail-row'>
                            <div className='box-pdca-blacklist-detail-label'>
                              {nls.fieldTitle}
                            </div>
                            <div className='box-pdca-blacklist-detail-value'>
                              {selecionada.titulo || nls.notAvailable}
                            </div>
                          </div>

                          <div className='box-pdca-blacklist-detail-row'>
                            <div className='box-pdca-blacklist-detail-label'>
                              {nls.fieldDescription}
                            </div>
                            <div className='box-pdca-blacklist-detail-value box-pdca-blacklist-detail-value-description'>
                              {selecionada.descricao || nls.notAvailable}
                            </div>
                          </div>

                          <div className='box-pdca-blacklist-detail-row'>
                            <div className='box-pdca-blacklist-detail-label'>
                              {nls.fieldSector}
                            </div>
                            <div className='box-pdca-blacklist-detail-value'>
                              {selecionada.setor || nls.notAvailable}
                            </div>
                          </div>

                          <div className='box-pdca-blacklist-detail-actions'>
                            <Button
                              color='error'
                              onClick={handleRemover}
                              disabled={removing && removingId === selecionada.id}
                            >
                              {removing && removingId === selecionada.id
                                ? nls.removing
                                : nls.remove}
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <PdcaEmptyState title={nls.selectOne} />
                      )}
                    </div>
                  </div>
                ) : (
                  <PdcaEmptyState title={nls.emptyState} />
                )}
              </>
            )}
          </LoadingContent>
        )}
      </div>
    </PdcaLayout>
  )
}